<script setup lang="ts">
const { activeVariant } = storeToRefs(useProductVariantsStore())
</script>

<template>
  <div class="space-y-5 md:max-w-xl">
    <UProductImage
      :product="activeVariant"
      class="flex h-44 justify-center md:h-52"
      img-class="object-contain"
    />
    <h2
      class="text-center font-national2condensed text-paywall-mobile-title text-[--theme-dark] md:text-paywall-desktop-title"
      v-text="activeVariant?.isFree ? 'Få kunnskapen først!' : 'Lås opp resten av kunnskapen!'"
    />
  </div>
</template>
